import { instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { AboutUsData } from "../../content.types";

export const requestGetAboutUs = async (): Promise<AboutUsData> => {
  return await instance.get(ApiRoutesContent.AboutUs);
};
